<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100vh">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" mobile="12">
                <grid-row class="mt-mobile-15 justify-content-center align-content-between h-100 pb-30">
                    <grid-col col="12">
                        <div class="font-400 font-size-24px color-base-700 line-h-32">
                            {{ "SelectPaymentMethod" | translate }}
                        </div>
                        <div class="custom-radio mt-30">
                            <input type="radio" value="Outstanding amount" id="radio-1" name="radioGroup2"  (change)="SelectGateway($event,1)" >
                            <label for="radio-1">
                                <grid-row class="justify-content-between align-item-center">
                                    <grid-col col="auto">
                                        <div class="font-600 font-size-14px line-h-22">
                                            {{"BenefitGateway" | translate}}
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <div class="font-500 font-size-14px line-h-20">
                                            <ng-icon iconClass="icon-getway" width="32" height="32"></ng-icon>
                                        </div>
                                    </grid-col>
                                </grid-row>
                            </label>
                        </div>
                        <div class="custom-radio mt-20">
                            <input type="radio" value="Outstanding amount" id="radio-2" name="radioGroup2" (change)="SelectGateway($event,2)" >
                            <label for="radio-2">
                                <grid-row class="justify-content-between align-item-center">
                                    <grid-col col="auto">
                                        <div class="font-600 font-size-14px line-h-22">
                                            {{"BenefitPay" | translate}}
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <div class="font-500 font-size-14px line-h-20">
                                            <ng-icon iconClass="icon-benifit" width="32" height="32"></ng-icon>
                                        </div>
                                    </grid-col>
                                </grid-row>
                            </label>
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="justify-content-between mt-20">
                            <grid-col col="auto">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </grid-col>
                            <grid-col col="9">
                            <button class="btn-dft" [disabled]="this.selectedgateway == false" (click)="payCardSuccess()">
                                {{ "PAY" | translate }}
                            </button>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
       
    </div>
</div>